import getAppSite from 'utils/getAppSite';
import configDataUSA from './usa.json';
import configDataUK from './global.json';

class ConfigDataClass {
  getConfig() {
    try {
      return getAppSite() === 'usa' ? configDataUSA : configDataUK;
    } catch (e) {}
  }
}

const SiteConfigData = new ConfigDataClass();
const ConfigData = SiteConfigData.getConfig();
export default ConfigData;
